import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { AccessibilityProvider } from './context/AccessibilityContext';
import { Toaster } from './components/ui/sonner';
import ProtectedRoute from './components/ProtectedRoute';
import AppShell from './components/AppShell';
import AndroidBridge from './AndroidBridge';
import Landing from './pages/Landing';
import Dashboard from './pages/Dashboard';
import Hub from './pages/Hub';
import Remote from './pages/Remote';
import Services from './pages/Services';
import Watchlist from './pages/Watchlist';
import Folders from './pages/Folders';
import Reminders from './pages/Reminders';
import Pricing from './pages/Pricing';
import Settings from './pages/Settings';
import QMate from './pages/QMate';
import Mood from './pages/Mood';
import WatchDNA from './pages/WatchDNA';
import Scores from './pages/Scores';
import ExtensionToken from './pages/ExtensionToken';
import ExtensionConnect from './pages/ExtensionConnect';
import ShowDetail from './pages/ShowDetail';
import Onboarding from './pages/Onboarding';
import Suggest from './pages/Suggest';
import AppSwitchConfirm from './pages/AppSwitchConfirm';
import InferenceConfirm from './pages/InferenceConfirm';
import FireTVPair from './pages/FireTVPair';
import FireTVStatus from './pages/FireTVStatus';
import FireTVAdbControl from './pages/FireTVAdbControl';
import Profile from './pages/Profile';
import History from './pages/History';
import Discover from './pages/Discover';
import SpoilerShield from './pages/SpoilerShield';
import DetectionLab from './pages/DetectionLab';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AndroidBridge />
        <AccessibilityProvider>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/onboarding" element={<ProtectedRoute><Onboarding /></ProtectedRoute>} />
            {/* Loaded directly inside the Fire TV app's WebView -- no AppShell
                chrome, this is a dedicated TV screen, not a website page. */}
            <Route path="/firetv-pair" element={<ProtectedRoute><FireTVPair /></ProtectedRoute>} />
            <Route path="/firetv-status" element={<ProtectedRoute><FireTVStatus /></ProtectedRoute>} />
            <Route element={<ProtectedRoute><AppShell /></ProtectedRoute>}>
              <Route path="/dashboard" element={<Navigate to="/hub" replace />} />
              <Route path="/hub" element={<Hub />} />
              <Route path="/detection-lab" element={<DetectionLab />} />
              {/* Remote is mobile-app-only -- the website doesn't need it.
                  window.QudeAndroid only exists inside the native app's WebView. */}
              <Route path="/remote" element={
                typeof window !== 'undefined' && window.QudeAndroid ? <Remote /> : <Navigate to="/hub" replace />
              } />
              <Route path="/services" element={<Services />} />
              <Route path="/watchlist" element={<Watchlist />} />
              <Route path="/folders" element={<Folders />} />
              <Route path="/reminders" element={<Reminders />} />
              <Route path="/qmate" element={<QMate />} />
              <Route path="/scores" element={<Scores />} />
              <Route path="/sports" element={<Scores />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/mood" element={<Mood />} />
              <Route path="/watch-dna" element={<WatchDNA />} />
              <Route path="/extension-token" element={<ExtensionToken />} />
              <Route path="/extension-connect" element={<ExtensionConnect />} />
              <Route path="/show/:tmdbId" element={<ShowDetail />} />
              <Route path="/suggest/:suggestionId" element={<Suggest />} />
              <Route path="/app-switch/:candidateId" element={<AppSwitchConfirm />} />
              <Route path="/inference/:sessionId" element={<InferenceConfirm />} />
              <Route path="/firetv-adb" element={<FireTVAdbControl />} />
              <Route path="/profile/:username" element={<Profile />} />
              <Route path="/history" element={<History />} />
              <Route path="/discover" element={<Discover />} />
              <Route path="/spoiler-shield" element={<SpoilerShield />} />
            </Route>
          </Routes>
          <Toaster position="top-right" theme="dark" />
        </AccessibilityProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
